<template>
	<div class="filter form">
		<div class="item" data-size="medium">
			<input class="textbox" type="text" :placeholder="localizer.get('PrivateArea.Common.ProjectDetail_FilterBox_SearchText_Placeholder')" @keyup.enter="setSearch()" v-model="searchText" />
		</div>
		<div class="item" data-cta="multi">
			<div class="cta">
				<button class="button" @click="setSearch()" data-size="small" :style="[{ 'background-color': accentColor }]">
					{{ localizer.get("PrivateArea.Common.ProjectDetail_FilterBox_SearchButton") }}
				</button>
			</div>
			<div class="cta" v-if="searchText">
				<button class="button" data-type="link" @click="resetSearch()">
					{{ localizer.get("PrivateArea.Common.ProjectDetail_FilterBox_ResetFilters") }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Localizer from "@Scripts/Common/Localizer";

const props = defineProps<{
	accentColor: string;
}>();

const route = useRoute();
const router = useRouter();
const localizer = Localizer;
const searchText = ref<string | null>(null);
const isProject = ref(true);
const isAsset = ref(false);

onMounted(() => {
	let searchObj = JSON.parse(window.sessionStorage.getItem("ProcessSearch"));
	window.sessionStorage.removeItem("AssetSearch");

	if (route.query.searchtext) {
		searchText.value = <string>route.query.searchtext;
	} else if (searchObj?.searchtext) {
		searchText.value = searchObj.searchtext;
	}

	if (route.query.isproject) {
		isProject.value = route.query.isproject === "true";
	} else if (searchObj?.isproject) {
		isProject.value = searchObj.isproject;
	}

	if (route.query.isasset) {
		isAsset.value = route.query.isasset === "true";
	} else if (searchObj?.isasset) {
		isAsset.value = searchObj.isasset;
	}

	if (searchObj != null && !route.query.searchtext && !route.query.isproject && !route.query.isasset) {
		router.replace({ path: window.location.pathname, query: { searchtext: searchText.value, isproject: isProject.value ? "true" : "false", isasset: isAsset.value ? "true" : "false" } }).catch(() => { });
	}
});

function resetSearch() {
	searchText.value = null;

	setSearch();
}

function setSearch() {
	const query = { 
		searchtext: searchText.value, 
		isproject: isProject.value ? "true" : "false", 
		isasset: isAsset.value ? "true" : "false" 
	};
	
	window.sessionStorage.setItem("ProcessSearch", JSON.stringify(query));

	const params = new URLSearchParams();
	if (searchText.value) 
	{
		params.set('searchtext', searchText.value)
	};
	params.set('isproject', isProject.value ? "true" : "false");
	params.set('isasset', isAsset.value ? "true" : "false");
	
	window.location.href = window.location.pathname + '?' + params.toString();
}
</script>
